/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { DISABLED_MATCHER_PROVIDER, DynamicFormsCoreModule, HIDDEN_MATCHER_PROVIDER } from '@myprofile-ui/myprofile-dynamic-forms'
import { LOCALISATION_BASE_URL, LOCALISATION_VERSION } from '@myprofile-ui/myprofile-localisation-api'
import { PidxInlineFormMessagesModule, PidxLoaderModule, PidxSkeletonLoaderModule } from '@myprofile-ui/pidx-ui-components'
import { PidxUtilsModule } from '@myprofile-ui/pidx-utils'
import { TranslatePipe } from '@ngx-translate/core'
import { NgxsModule } from '@ngxs/store'
import { MyProfileAddressEditFormComponent } from './components/myprofile-address-editform/myprofile-address-editform.component'
import { MyProfileAddressListCheckoutComponent } from './components/myprofile-address-list-checkout/myprofile-address-list-checkout.component'
import { MyProfileAddressListMylantaComponent } from './components/myprofile-address-list-mylanta/myprofile-address-list-mylanta.component'
import { MyProfileAddressListComponent } from './components/myprofile-address-list/myprofile-address-list.component'
import { MyProfileAddressWidgetComponent } from './myprofile-address-widget.component'
import { AddressWidgetState } from './store/address-widget.state'
import { RESTRICT_GLOBAL_UI_CHANGES } from '../../../pidx-utils/src/lib/helpers/restrictGlobalUIChanges.injectionToken'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'
import { BASE_PATH } from '@myprofile-ui/pidx-utils'

@NgModule({
  declarations: [
    MyProfileAddressWidgetComponent,
    MyProfileAddressEditFormComponent,
    MyProfileAddressListComponent,
    MyProfileAddressListCheckoutComponent,
    MyProfileAddressListMylantaComponent,
  ],
  exports: [MyProfileAddressWidgetComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PidxInlineFormMessagesModule,
    PidxLoaderModule,
    PidxSkeletonLoaderModule,
    PidxUtilsModule,
    DynamicFormsCoreModule,
    NgxsModule.forFeature([AddressWidgetState]),
    TranslatePipe,
    PorscheDesignSystemModule,
  ],
  providers: [DISABLED_MATCHER_PROVIDER, HIDDEN_MATCHER_PROVIDER, provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class MyProfileAddressWidgetModule {
  static forRoot(
    basePath: string,
    localisationBasePath: string,
    isProduction: boolean,
    restrictGlobalUIChanges: boolean,
  ): ModuleWithProviders<MyProfileAddressWidgetModule> {
    return {
      ngModule: MyProfileAddressWidgetModule,
      providers: [
        { provide: BASE_PATH, useValue: basePath },
        { provide: LOCALISATION_BASE_URL, useValue: localisationBasePath },
        { provide: LOCALISATION_VERSION, useValue: isProduction ? 'RELEASE' : 'LATEST' },
        { provide: RESTRICT_GLOBAL_UI_CHANGES, useValue: restrictGlobalUIChanges },
      ],
    }
  }
}
